module.exports = __webpack_public_path__ + "img/mainPage.0710f7e7.svg";